import React, { useEffect, useState } from "react"
import intl from "react-intl-universal"
import { Flex, toast } from "@stardust-ds/react"
import styles from "./index.module.scss"

import { useTableFormLaunch } from "../tableFormLaunchs/context"
import ModalComponent from "../../../../components/ModalComponent"
import Button from "../../../../../../atoms/Button"
import { AlertTriangule } from "../../../../../../../assets/icons/AlertTringule"
import useDataApi from "../../../../../../../hooks/useDataApi"
import {
  deleteRun,
  verifyLaunchHasManualAverage,
} from "../../../../../../../services/ciq"
import { ModalInformation } from "../../../../components/ModalInformation"

const ModalDeleteRun = (props) => {
  const { fetchRuns } = props
  const { oRunDelete, setORunDelete } = useTableFormLaunch()
  const [
    bConfirmDeleteManualAverageModalIsOpen,
    setBConfirmDeleteManualAverageModalIsOpen,
  ] = useState(false)

  const nRunId = oRunDelete?.eqpanltrun_nid
  const nRunNumber = oRunDelete?.eqpanltrun_number
  const [oDeleteRunRes, fnDeleteRunReq] = useDataApi(deleteRun)
  const [
    oLaunchesHasManualAverage,
    fnLaunchesHasManualAverageReq,
    fnResetLaunchHasManualAverageReq,
  ] = useDataApi(verifyLaunchHasManualAverage)

  useEffect(() => {
    if (oDeleteRunRes.loading || !oDeleteRunRes.done) return

    if (oDeleteRunRes.data) {
      toast({
        type: "success",
        title: intl.get("ciq.release_details.modal_remove_run.success_title"),
        description: intl.get(
          "ciq.release_details.modal_remove_run.success_description",
          {
            run: nRunNumber,
          },
        ),
      })
      onCloseDeleteRunModal()
      fetchRuns()
    }

    if (oDeleteRunRes.error) {
      onCloseDeleteRunModal()
      if (oDeleteRunRes.error?.response?.status === 409) {
        toast({
          type: "error",
          title: intl.get("ciq.release_details.modal_remove_run.error_title"),
          description: intl.get(
            "ciq.release_details.modal_remove_run.error_description_conflict",
            {
              run: nRunNumber,
            },
          ),
        })
        return
      }

      const cErrorMessage = oDeleteRunRes.error?.response?.data?.message

      if (cErrorMessage?.toLowerCase() === "run not found") {
        toast({
          type: "error",
          title: intl.get("ciq.release_details.modal_remove_run.error_title"),
          description: intl.get(
            "ciq.release_details.modal_remove_run.error_description_not_found",
            {
              run: nRunNumber,
            },
          ),
        })

        return
      }

      if (cErrorMessage?.toLowerCase() === "run is not the last run") {
        toast({
          type: "error",
          title: intl.get("ciq.release_details.modal_remove_run.error_title"),
          description: intl.get(
            "ciq.release_details.modal_remove_run.error_description_not_last_run",
            {
              run: nRunNumber,
            },
          ),
        })

        return
      }

      toast({
        type: "error",
        title: intl.get("ciq.release_details.modal_remove_run.error_title"),
        description: intl.get("ciq.release_details.modal_remove_run.error_description", {
          run: nRunNumber,
        }),
      })
    }
  }, [oDeleteRunRes])

  if (!nRunId) return null

  const onCloseDeleteRunModal = () => {
    if (oDeleteRunRes.loading) return
    setORunDelete(null)
    fnResetLaunchHasManualAverageReq()
    setBConfirmDeleteManualAverageModalIsOpen(false)
  }

  const handleDeleteRun = async () => {
    if (oDeleteRunRes.loading || oLaunchesHasManualAverage.loading) return

    const aLaunchesNIds = oRunDelete?.eqpanltrun_launches?.map(launch => launch?.eqpanltlaunch_nid)
    if (aLaunchesNIds && !oLaunchesHasManualAverage?.data?.data?.hasManualAverage) {
      const responseHasManualAverage = await fnLaunchesHasManualAverageReq(aLaunchesNIds?.join(","), 'verify_only_disabled_manual_average=true')
      if (responseHasManualAverage?.data?.hasManualAverage) {
        setBConfirmDeleteManualAverageModalIsOpen(true)
        return
      }
    }

    await fnDeleteRunReq(nRunId)
  }

  const elModalTitle = (
    <span className={styles.centerModalTitle}>
      {intl.get("ciq.release_details.modal_remove_run.title")}
    </span>
  )

  return (
    <>
      <ModalComponent
        title={elModalTitle}
        fnCloseModal={onCloseDeleteRunModal}
        size="sm"
        className={styles.removeRunModalContainer}
      >
        <Flex
          width="100%"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap="16px"
          className={styles.removeRunModal}
        >
          <AlertTriangule className={styles.removeRunAlert} />
          <p>
            {intl.get("ciq.release_details.modal_remove_run.description", {
              run: nRunNumber,
            })}
          </p>
          <Flex
            gap="8px"
            alignItems="center"
            justifyContent="space-between"
            style={{ marginTop: 8 }}
          >
            <Button type="buttom" variant="outline" onClick={onCloseDeleteRunModal}>
              {intl.get("ciq.release_details.modal_remove_run.cancel_button")}
            </Button>
            <Button
              type="buttom"
              variant="negative"
              onClick={handleDeleteRun}
              isLoading={oLaunchesHasManualAverage.loading || oDeleteRunRes.loading}
            >
              {intl.get("ciq.release_details.modal_remove_run.confirm_button")}
            </Button>
          </Flex>
        </Flex>
      </ModalComponent>
      {bConfirmDeleteManualAverageModalIsOpen && (
        <ModalInformation
          title={intl.get("ciq.release_details.modal_confirm_update_launch.title")}
          description={intl.get(
            "ciq.release_details.modal_confirm_update_launch.description",
          )}
          onCancel={onCloseDeleteRunModal}
          onClose={onCloseDeleteRunModal}
          type="submit"
          onSubmit={handleDeleteRun}
          isLoad={oDeleteRunRes.loading}
        />
      )}
    </>
  )
}

export default ModalDeleteRun
